import jwt_decode from "jwt-decode";

export const decodeJwt = (token: string): Record<string, unknown> => {
  try {
    return jwt_decode(token);
  } catch (err) {
    return {};
  }
};
